import { Component, OnInit ,Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-registration-required',
  templateUrl: './registration-required.component.html',
  styleUrls: ['./registration-required.component.scss']
})
export class RegistrationRequiredComponent {
  message: string = '';

  constructor(private router: Router,
    private dialogRef: MatDialogRef<RegistrationRequiredComponent>,
    @Inject(MAT_DIALOG_DATA) data: { message: string }
  ) {
    this.message = data ? data.message : '';
  }

  closeAlert() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }
  
  register() {
    // Navigate to the desired relative route
    this.router.navigateByUrl('/student-exam-payment');
    this.closeAlert();
  }
}